'use client';
import cn from 'classnames';
import {
  MinusIcon,
  PlusIcon,
  PresentationChartBarIcon,
} from '@heroicons/react/24/outline';
import { type Session } from 'next-auth';
import { type ReactNode, useState } from 'react';
import { getServerMetrics } from './actions';

type Props = {
  session?: Session | null;
  children?: ReactNode;
};

export const DebugPanel = ({ session, children }: Props) => {
  const [isDebugOpen, setIsDebugOpen] = useState(false);

  if (!session) return null;

  return (
    <div
      onClick={() => !isDebugOpen && setIsDebugOpen(true)}
      className={cn({
        'fixed h-auto bottom-2 space-y-2 left-2 rounded-xl border bg-white px-5 py-4 opacity-40 hover:opacity-100':
          true,
        btn: !isDebugOpen,
      })}
      data-testid="debug-panel"
    >
      {isDebugOpen ? (
        <>
          <div className="flex items-center justify-between gap-2">
            <p className="text-lg font-light">
              Debug Panel{' '}
              <span className="text-neutral-400 text-xs font-extralight">
                (not in prod)
              </span>
            </p>
            <div className="flex items-center gap-2">
              <div className="tooltip" data-tip="Console log metrics">
                <PresentationChartBarIcon
                  onClick={async () => {
                    const metrics = await getServerMetrics();
                    console.info(`Metrics:\n${metrics}`);
                  }}
                  className="size-6 btn btn-xs btn-circle"
                />
              </div>
              <div className="tooltip" data-tip="Minimize">
                <MinusIcon
                  onClick={() => setIsDebugOpen(false)}
                  className="size-6 btn btn-xs btn-circle"
                />
              </div>
            </div>
          </div>
          {children}
        </>
      ) : (
        <PlusIcon className="block size-7 m-0" />
      )}
    </div>
  );
};
